import classNames from 'classnames';
import * as _ from 'lodash';
import { ReactNode } from 'react';

import { setupForDark } from '@theme';

export default function ToggleButton({
  children,
  onClick = _.noop,
  size = 'medium',
  selected = false,
  disabled = false,
  fullWidth = false,
  className = '',
  'data-testid': dataTestId
}: {
  children: ReactNode;
  onClick: any;
  size?: 'large' | 'medium' | 'small';
  selected?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  'data-testid'?: string;
}) {
  let typeClasses = '';
  if (!disabled && !selected) {
    typeClasses = classNames(setupForDark('bg-primary text-primary'));
  } else if (!disabled && selected) {
    typeClasses = classNames(setupForDark('bg-toggle-btn-selected text-toggle-btn-selected'));
  } else if (disabled && !selected) {
    typeClasses = classNames(
      setupForDark(
        'bg-toggle-btn-unselected-disabled text-toggle-btn-unselected-disabled border border-primary'
      )
    );
  } else if (disabled && selected) {
    typeClasses = classNames(
      setupForDark('bg-toggle-btn-selected-disabled text-toggle-btn-selected-disabled')
    );
  }

  let sizeClasses = '';
  switch (size) {
    case 'large':
      sizeClasses = classNames('pt-sm pb-sm pl-xl pr-xl rounded-md min-w-[150px] min-h-[80px] H5');
      break;

    case 'medium':
      sizeClasses = classNames('pt-sm pb-sm pl-xl pr-xl rounded-xs', 'P2M');
      break;

    case 'small':
      sizeClasses = classNames('pt-xs pb-xs pl-lg pr-lg rounded-xs', 'P3M');
      break;
  }

  onClick = disabled ? _.noop : onClick;

  return (
    <div
      data-testid={dataTestId}
      className={classNames(
        'flex flex-col items-center justify-center gap-xs',
        disabled ? '' : 'cursor-pointer',
        typeClasses,
        sizeClasses,
        fullWidth ? 'w-full' : '',
        className
      )}
      onClick={onClick}
    >
      <div>{children}</div>
    </div>
  );
}
